// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"662":"25e8f1209d1ca01036f1","966":"84f510c935c37980b015"}[chunkId] + ".js";
};